module.exports = __webpack_public_path__ + "media/media/product-card/vlsat_base_empty-d999ec3c7a0b30dec7ac24ba01fa4ca2.jpeg";